import { X } from "lucide-react";
import { useEffect } from "react";

const BottomSheet = ({
  isOpen,
  onClose,
  children,
  className = "",
  showCloseButton = true,
  height = "80vh",
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-black opacity-0 animate-fadeIn z-40"
        onClick={onClose}
      />
      <div
        className={`fixed bottom-0 left-0 right-0 bg-white z-50 rounded-t-[16px] md:left-1/2 md:-translate-x-1/2 md:max-w-[900px] w-[100%] ${className}`}
        style={{ maxHeight: height }}
      >
        <div className="relative">
          <div className="px-[20px] md:px-[40px]">
            {showCloseButton && (
              <div className="absolute top-5 right-5">
                <button
                  onClick={onClose}
                  className="cursor-pointer rounded-full bg-[#C4C4C4]"
                >
                  <X className="w-[24px] h-[24px] text-white" />
                </button>
              </div>
            )}
          </div>
        </div>
        <div
          className="overflow-y-auto px-[20px] md:px-[40px] md:pb-[40px]"
          style={{ maxHeight: `calc(${height} - 80px)` }}
        >
          {children}
        </div>
      </div>
    </>
  );
};

export default BottomSheet;
